export default {
  en: {
    labels: {
      discovery: 'Discovery',
    },
  },
  es: {
    labels: {
      discovery: 'こんにちは、世界',
    },
  },
};
